/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TagRegularDiagonal from './tag-regular-diagonal-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TagRegularDiagonal {...validProps} />;
}

SvgComponent.iconName = 'tagRegularDiagonal';

export const TagRegularDiagonalIcon = svgIconWrapper(SvgComponent);
